import {makeAutoObservable} from 'mobx';
import {RequestBody} from '../../entity/core/request-body';
import TitleTemplateAgent from '../agent/title-template-agent';
import {TitleTemplate} from '../../entity/model/title-template';
import {TitleBankCache} from '../../entity/resource/title-bank-cache';

export default class TitleTemplateStore {
  titleTemplateAgent: TitleTemplateAgent;
  titleTemplate?: TitleTemplate;
  titleBankCache?: TitleBankCache;

  constructor(titleTemplateAgent: TitleTemplateAgent) {
    makeAutoObservable(this);
    this.titleTemplateAgent = titleTemplateAgent;
  }

  getTitleTemplateById = async (organizationId: string, titleTemplateId: string): Promise<TitleTemplate | undefined> => {
    try {
      const response =  await this.titleTemplateAgent.getTitleTemplateById(organizationId, titleTemplateId);
      this.titleTemplate = response;

      return response;
    } catch (error: any) {
      console.error('Error occurred while fetch the title template', error);
    }
  }

  exportTitleTemplate = async (organizationId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      await this.titleTemplateAgent.exportTitleTemplate(organizationId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while exporting the title template', error);
      return 'Error occurred while exporting the title template !!';
    }
  }

  importTitleTemplate = async (organizationId: string, titleId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      await this.titleTemplateAgent.importTitleTemplate(organizationId, titleId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while importing the title template', error);
      return 'Error occurred while importing the title template !!';
    }
  }

  updateTitleTemplate = async (organizationId: string, titleTemplateId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      await this.titleTemplateAgent.updateTitleTemplate(organizationId, titleTemplateId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while updating the title template', error);
      return 'Error occurred while updating the title template !!';
    }
  }

  deleteTitleTemplate = async (organizationId: string, titleTemplateId: string): Promise<string | undefined> => {
    try {
      await this.titleTemplateAgent.deleteTitleTemplate(organizationId, titleTemplateId);
    } catch (error: any) {
      console.error('Error occurred while deleting the title template', error);
      return 'Error occurred while deleting the title template !!';
    }
  }

  cloneTitleTemplate = async (organizationId: string, titleTemplateId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      await this.titleTemplateAgent.cloneTitleTemplate(organizationId, titleTemplateId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while cloning the title template', error);
      return 'Error occurred while cloning the title template !!';
    }
  }
}
